module.exports = __webpack_public_path__ + "media/effects-14.432e780e.webm";